import { ApiResult, Canceler, request, safeRequest } from '@synergy/api';
import { Media } from '@synergy/models';

import { DemandDetail } from '../models/demand-detail';
import { DemandDetailAccount } from '../models/demand-detail-account';
import { DemandDetailFormValues } from '../models/demand-detail-form-values';

export class DemandsDetailApi {
    private canceler?: Canceler;

    constructor(protected baseUrl: string) {}

    public get = (id: number): Promise<ApiResult<DemandDetail>> => {
        this.canceler?.();

        return safeRequest(
            () =>
                request.get<DemandDetail>(`${this.baseUrl}/demands/${id}`, {
                    cancelToken: new request.CancelToken(c => (this.canceler = c)),
                }),
            response => {
                const demand = response.data;
                if (demand.media) {
                    demand.media = demand.media.map(Media.fromPlainObject);
                }

                return demand;
            }
        );
    };

    public updateDemandAccount(values: DemandDetailFormValues, id: number): Promise<ApiResult<DemandDetailAccount>> {
        const uploadedFiles = values.files
            .filter(file => file.originalName && !!file.contentBase64)
            .map(file => ({
                name: file.originalName,
                contentBase64: file.contentBase64,
            }));

        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/demands/${id}/submit`, {
                    id,
                    demandAccountId: values.id >= 0 ? values.id : undefined,
                    noteFromCustomer: values.noteFromCustomer,
                    items: values.demandAccountItems.map(item => {
                        return {
                            deliveryAddressId: item.deliveryAddress && item.deliveryAddress.id,
                            quantity: item.quantity,
                            demandItemId: item.demandItemId,
                            id: item.id,
                            noDemand: item.noDemand,
                        };
                    }),
                    files: uploadedFiles,
                }),
            response => {
                const demandAccount = response.data;
                if (demandAccount.media) {
                    demandAccount.media = demandAccount.media.map(Media.fromPlainObject);
                }
                return demandAccount;
            }
        );
    }
}
